import { useFormik } from "formik"
import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import * as Yup from "yup"
import {
  Col,
  Row,
  Form,
  Label,
  Input,
  FormFeedback,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap"
import {
  addNewCategoryUser,
  categoryUserError,
} from "store/manageclient/action"
import { Countries } from "../ManageUser/countries"
import Select from "react-select"
import { postUserCategorylink } from "store/manageclient/action"
import { isEmpty } from "lodash"

const UserForm = ({
  handleUserCancel,
  selectedCategory,
  selectedRow,
  isEdit,
  toggle,
  updateUserCategoryLink,
  categoryUsers,
  updateUserlinks,
  categoryId
}) => {
  const dispatch = useDispatch()

  const countrydropdown = {
    label: selectedRow?.country,
    value: selectedRow?.country,
  }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      firstname: isEdit ? selectedRow?.firstName : "",
      lastname: isEdit ? selectedRow?.lastName : "",
      email: isEdit ? selectedRow?.email : "",
      country: isEdit ? countrydropdown : "",
      reportrecipient: isEdit ? selectedRow?.reportRecipient : false,
      active: isEdit ? selectedRow?.active : false,
      password: isEdit ? selectedRow?.active : "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string().required("Please Enter your First Name"),
      lastname: Yup.string().required("Please Enter your Last Name"),
      email: Yup.string().required("Please Enter your Email"),
      password: Yup.string().required("Please Enter your Password").min(6),
    }),
    onSubmit: values => {
      if (isEdit) {
        const EditUser = {
          id: selectedRow?.id,
          categoryid: selectedCategory?.categoryId || categoryId || selectedRow.categoryid,
          firstname: values?.firstname,
          lastname: values?.lastname,
          country: values?.country?.value,
          email: values?.email,
          reportrecipient: values?.reportrecipient,
          active: values?.active,
          password: values?.password,
        }
        dispatch(addNewCategoryUser(EditUser, handleResponse))
      } else {
        const addnewUser = {
          categoryid: selectedCategory?.categoryId || categoryId,
          firstname: values?.firstname,
          lastname: values?.lastname,
          email: values?.email,
          country: values?.country.name,
          reportrecipient: values?.reportrecipient,
          active: values?.active,
          password: values?.password,
        }
        dispatch(addNewCategoryUser(addnewUser, handleResponse))
      }
    },
  })

  const handleResponse = status => {
    if (status === "SUCCESS") {
      toggle()
      validation.resetForm()
    }
  }
  const handleKeyDown = e => {
    if (e.keyCode === 32) {
      e.preventDefault()
    }
  }
  // Show another popup for condition

  const [modal, setModal] = useState(false)
  useEffect(() => {
    if (
      updateUserCategoryLink?.message == "Email already exist with another user"
    ) {
      setModal(true)
    }
  }, [updateUserCategoryLink])

  const exitUsertoggle = () => {
    if (modal) {
      setModal(false)
      dispatch(categoryUserError())
    } else {
      setModal(true)
    }
  }
  const handleUserCategoryLink = () => {
    const userlinkparams = {
      email: validation.values.email,
      categoryid: [categoryUsers?.categoryId],
    }
    dispatch(postUserCategorylink(userlinkparams))
  }
  useEffect(() => {
    if (updateUserlinks == 200) {
      toggle();
      validation.resetForm();
      setModal(false);
      dispatch(categoryUserError());
    }
  }, [updateUserlinks])
  const staticPreviewCountry = [
    { name: 'Australia', code: 'AU' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'United States', code: 'US' },
    { name: 'United Kingtom', code: 'GB' },
    { name: 'India', code: 'IN' }
  ]

  const filtecountry = !isEmpty(Countries) ? Countries?.filter(el => staticPreviewCountry?.find(item => item?.name == el?.name)?.name !== el?.name) : []
  return (
    <>
      <Form
        noValidate
        onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}
      >
        <Row form>
          <Col>
            <div className="mb-3">
              <Label for="firstname" className="form-label">
                First Name
              </Label>
              <Input
                name="firstname"
                classfirstname="form-control"
                placeholder="Enter your Your Name"
                type="text"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.firstname || ""}
                invalid={
                  validation.touched.firstname && validation.errors.firstname
                    ? true
                    : false
                }
              />
              {validation.touched.firstname && validation.errors.firstname ? (
                <FormFeedback type="invalid">
                  {validation.errors.firstname}
                </FormFeedback>
              ) : null}
            </div>

            <div className="mb-3">
              <Label className="form-label">Last Name</Label>
              <Input
                id="lastname"
                name="lastname"
                className="form-control"
                placeholder="Enter your Last Name"
                type="text"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.lastname || ""}
                invalid={
                  validation.touched.lastname && validation.errors.lastname
                    ? true
                    : false
                }
              />
              {validation.touched.lastname && validation.errors.lastname ? (
                <FormFeedback type="invalid">
                  {validation.errors.lastname}
                </FormFeedback>
              ) : null}
            </div>
            <div className="mb-3">
              <Label className="form-label">Password</Label>
              <Input
                autoComplete="new-password"
                id="password"
                name="password"
                className="form-control"
                placeholder="Enter your Password"
                type="password"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.password || ""}
                invalid={
                  validation.touched.password && validation.errors.password
                    ? true
                    : false
                }
              />
              {validation.touched.password && validation.errors.password ? (
                <FormFeedback type="invalid">
                  {validation.errors.password}
                </FormFeedback>
              ) : null}
            </div>
            <div className="mb-3">
              <Label for="email" className="form-label">
                Email
              </Label>
              <Input
                autoComplete="new-password"
                name="email"
                id="email"
                className="form-control"
                placeholder="Enter Your Email"
                type="email"
                onChange={(e)=>{
                  validation.setFieldValue("email", e.target.value.replace(/ /g,''))
                 }}
                onBlur={validation.handleBlur}
                value={validation.values.email}
                invalid={
                  validation.touched.email && validation.errors.email
                    ? true
                    : false
                }
                onKeyDown={handleKeyDown}
              />
              {validation.touched.email && validation.errors.email ? (
                <FormFeedback type="invalid">
                  {validation.errors.email}
                </FormFeedback>
              ) : null}
            </div>
            <div className="mb-3">
              <Label className="form-label">Country</Label>
              <Select
                isClearable
                id="country"
                name="country"
                placeholder="Please Select country"
                onBlur={validation.handleBlur}
                value={validation.values.country}
                classNamePrefix="select2-selection"
                onChange={value => {
                  validation.setFieldValue("country", value)
                }}
                invalid={
                  validation.touched.country && validation.errors.country
                    ? true
                    : false
                }
                options={([...staticPreviewCountry, ...filtecountry] || [])?.map(el => ({
                  ...el,
                  label: el?.name,
                  value: el?.name,
                }))}
              />
              {validation.touched.country && validation.errors.country ? (
                <FormFeedback type="invalid">
                  {validation.errors.country}
                </FormFeedback>
              ) : null}
            </div>
            <Row>
              <Col sm={4}>
                <div className="form-check mb-3">
                  <Input
                    className="form-check-input"
                    type="checkbox"
                    onChange={validation.handleChange}
                    defaultChecked={validation.values?.reportrecipient}
                    id="reportrecipient"
                  />
                  <Label className="form-check-label" htmlFor="reportrecipient">
                    Report Recipient
                  </Label>
                </div>
              </Col>
              <Col sm={4}>
                <div className="form-check mb-3">
                  <Input
                    className="form-check-input"
                    type="checkbox"
                    onChange={validation.handleChange}
                    defaultChecked={validation.values?.active}
                    id="active"
                  />
                  <Label className="form-check-label" htmlFor="active">
                    Active
                  </Label>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="text-end">
          <button type="submit" className="btn btn-primary save-customer me-2">
            Save
          </button>
          <button
            type="button"
            color="primary"
            className="btn btn-secondary"
            onClick={handleUserCancel}
          >
            Cancel
          </button>
        </div>
      </Form>
      <Modal isOpen={modal} toggle={exitUsertoggle} size="lg">
        <ModalHeader toggle={exitUsertoggle} tag="h4">
          Existing User
        </ModalHeader>
        <ModalBody>
          <div>
            <div className="modal-body">
              <h4 className="">
                Do you want to link existing user to{" "}
                <span style={{ color: "red" }}>
                  {categoryUsers?.categoryName}
                </span>
              </h4>
            </div>
            <div className="text-end">
              <button
                type="submit"
                className="btn btn-primary save-customer me-2"
                onClick={handleUserCategoryLink}
              >
                Yes
              </button>
              <button
                type="button"
                color="primary"
                className="btn btn-danger"
                onClick={exitUsertoggle}
              >
                No
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default UserForm
